import { Injectable, computed, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class QuickDepositMessageService {
    private inputQueue: string[] = [];
    private outputQueue: string[] = [];

    private inputSignal = signal<string>('');
    private outputSignal = signal<string>('');

    private inputProcessing = false;
    private outputProcessing = false;

    readonly input = computed(() => this.inputSignal());
    readonly output = computed(() => this.outputSignal());

    sendInput(message: string) {
        this.inputQueue.push(message);
        this.processNextInput();
    }

    sendOutput(message: string) {
        this.outputQueue.push(message);
        this.processNextOutput();
    }

    private processNextInput() {
        if (this.inputProcessing || this.inputQueue.length === 0) {
            return;
        }

        this.inputProcessing = true;
        const nextMessage = this.inputQueue.shift();
        if (nextMessage) {
            this.inputSignal.set(nextMessage);
        }

        setTimeout(() => {
            this.inputProcessing = false;
            this.processNextInput();
        }, 100);
    }

    private processNextOutput() {
        if (this.outputProcessing || this.outputQueue.length === 0) {
            return;
        }

        this.outputProcessing = true;
        const nextMessage = this.outputQueue.shift();
        if (nextMessage) {
            this.outputSignal.set(nextMessage);
        }

        setTimeout(() => {
            this.outputProcessing = false;
            this.processNextOutput();
        }, 100);
    }

    /** Fully clears all data and resets signals */
    destroy() {
        this.inputSignal.set('');
        this.outputSignal.set('');
        this.inputQueue = [];
        this.outputQueue = [];
    }
}
